<template>
    <div style="display: flex; flex-direction: column; background-color: #fff;">
        <div style="margin-top: 31px; position: relative; display: flex; align-items: center; justify-content: space-between; padding: 0 12px;">
            <div v-if="!is_from_pageframe" style="display:flex; align-items: center; " @click="() => { $GlobalStore.closeLastModal() }">
                <img :src="require('@/assets/img/ico-move_black.png')" style="width: 10px;">
                <span style="font-size:14px; font-weight:500; margin-left:5px; color:#210F03;">뒤로가기</span>
            </div>
            <div style="padding: 8px 16px; position: absolute; left: 50%; transform: translateX(-50%); display: inline-block; font-size: 14px; line-height: 20px; font-weight: 700; border-radius: 20px; background: #210F03E5; text-align: center; color: #fff;">
                {{ soccerhow.visit_cnt }}명이 조회
            </div>
            <div @click="setIsShowPopMenu" style="display: flex; flex-direction: column; gap: 3px; margin-left: auto;">
                <div style="width: 5px; height: 5px; background-color: #210f03; border-radius: 50%;"></div>
                <div style="width: 5px; height: 5px; background-color: #210f03; border-radius: 50%;"></div>
                <div style="width: 5px; height: 5px; background-color: #210f03; border-radius: 50%;"></div>
            </div>
        </div>
        <div v-if="Object.keys(soccerhow).length > 0" style="flex: 1; padding: 0 12px; overflow-y: auto; margin-top: 23px; background-color: #F7F8F9;">
            <div class="profile_header_section">
                <div class="profile_main">
                    <div style="position: relative;">
                        <ProfileImage :image-path="soccerhow.image_path" style="width: 80px; border: 2px solid #fff;"></ProfileImage>
                        <div :class="soccerhow.additional_info_player_type === 'elite' ? 'elite_tag' : 'not_elite_tag'" class="common_tag">
                            <div>{{ soccerhow.additional_info_player_type === 'elite' ? '엘리트 선수' : '비선출 선수' }}</div>
                        </div>
                    </div>
                    <div class="profile_info_main">
                        <div class="name_row_main">
                            <div class="player_name">
                                {{ soccerhow.additional_info_name || soccerhow.name }}
                                <span v-if="is_parent_verified == 1">
                                    <img style="width: 13px;" :src="require('@/assets/img/verified_parent.png')" alt="">
                                </span>
                            </div>
                        </div>
                        <div class="location">{{ soccerhow.place_name }}</div>
                        <span class="registration_date">{{ soccerhow.insert_date | dotDateStr }} 등록 <span style="color: #797979;" v-if="soccerhow.update_date && soccerhow.update_date !== soccerhow.insert_date">({{ soccerhow.update_date | dotDateStr }} 수정)</span></span>
                    </div>
                </div>
                <div style="margin-top: 23px;">
                    <div style="background-color: #F8F9FA; padding: 12px; border-radius: 12px;">
                        <div style="display: flex; gap: 90px; padding-bottom: 10px; border-bottom: 1px solid #d9d9d9;">
                            <div>
                                <div style="display: flex; align-items: center; gap: 5px;">
                                    <img style="width: 15px;" :src="require('@/assets/img/age_range_icon.png')" alt="">
                                    <div style="font-size: 12px; font-weight: 500; color: #808080;">연령</div>
                                </div>
                                <div style="font-weight: 700; line-height: 24px; margin-top: 2px;">{{ soccerhow.additional_info_grade || '-' }}</div>
                            </div>
                            <div>
                                <div style="display: flex; align-items: center; gap: 5px;">
                                    <img style="width: 15px;" :src="require('@/assets/img/hope_team_icon.png')" alt="">
                                    <div style="font-size: 12px; font-weight: 500; color: #808080;">희망 연령팀</div>
                                </div>
                                <div style="font-weight: 700; line-height: 24px; margin-top: 2px;">{{ soccerhow.additional_info_preferred_age_team || '-' }}</div>
                            </div>
                        </div>
                        <div style="padding-top: 10px;">
                            <div style="display: flex; align-items: center; gap: 5px;">
                                <img style="width: 13px;" :src="require('@/assets/img/loc_icon.png')" alt="">
                                <div style="font-size: 12px; font-weight: 500; color: #808080;">희망지역</div>
                            </div>
                            <div style="margin-top: 8px; display: flex; gap: 5px; flex-wrap: wrap;">
                                <div style="background-color: #fff; border: 1px solid #d9d9d9; border-radius: 8px; padding: 1px 11px; line-height: 24px; font-size: 14px; font-weight: 700;" v-for="each, i in soccerhow.additional_info_region ? soccerhow.additional_info_region.split(',') : []" :key="i + 'region'">{{ each }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="info_list">
                    <div class="info_item">
                        <span class="info_label">나이</span>
                        <span class="info_value">{{ soccerhow.additional_info_grade || '-' }}</span>
                    </div>
                    <div class="info_item">
                        <span class="info_label">선수 유형</span>
                        <span class="info_value">{{ soccerhow.additional_info_player_type === 'elite' ? '엘리트 선수' : '비선출 선수' }}</span>
                    </div>
                    <div class="info_item">
                        <span class="info_label">희망 연령팀</span>
                        <span class="info_value">{{ soccerhow.additional_info_preferred_age_team || '-' }}</span>
                    </div>
                    <div style="align-items: flex-start;" class="info_item">
                        <span style="white-space: nowrap; flex-shrink: 0;" class="info_label">희망 지역</span>
                        <span class="info_value" style="line-height: 24px;">{{ soccerhow.additional_info_region ? soccerhow.additional_info_region.replaceAll(',', '/') : '-' }}</span>
                    </div>
                    <div class="info_item">
                        <span class="info_label">작성일</span>
                        <span class="info_value">
                            {{ soccerhow.insert_date | dotDateStr }}
                            <span style="color: #797979;" v-if="soccerhow.update_date && soccerhow.update_date !== soccerhow.insert_date">({{ soccerhow.update_date | dotDateStr }} 수정)</span>
                        </span>
                    </div>
                </div> -->
            </div>

            <div class="section_container">
                <div class="section_header">
                    <span class="section_bar"></span>
                    <span class="section_title">신체 정보</span>
                </div>
                <div class="stats_section_detailed">
                    <div class="stat_item_detailed">
                        <div class="stat_label_detailed">포지션</div>
                        <div style="color: var(--color-main);" class="stat_value_detailed">{{ soccerhow.additional_info_position || soccerhow.position || '-' }}</div>
                    </div>
                    <div class="stat_item_detailed">
                        <div class="stat_label_detailed">신장</div>
                        <div class="stat_value_detailed">
                            <span class="stat_number">{{ soccerhow.height || soccerhow.additional_info_height || '-' }}</span>
                            <span v-if="soccerhow.height || soccerhow.additional_info_height" class="stat_unit">cm</span>
                        </div>
                    </div>
                    <div class="stat_item_detailed">
                        <div class="stat_label_detailed">체중</div>
                        <div class="stat_value_detailed">
                            <span class="stat_number">{{ soccerhow.additional_info_weight || '-' }}</span>
                            <span v-if="soccerhow.additional_info_weight" class="stat_unit">kg</span>
                        </div>
                    </div>
                    <div class="stat_item_detailed">
                        <div class="stat_label_detailed">주발</div>
                        <div class="stat_value_detailed">{{ transFootWay(soccerhow.foot_way) || transFootWay(soccerhow.additional_info_foot_way) || '-' }}</div>
                    </div>
                </div>
            </div>

            <div class="section_container">
                <div style="margin-bottom: 20px;" class="section_header">
                    <span class="section_bar"></span>
                    <span class="section_title">자기소개</span>
                </div>
                <div class="quote_box">
                    <div style="font-weight: 700; box-shadow: 0px 0px 10px 0px #0000001A; background-color: #fff8ee; text-align: center; padding: 12px;">
                        <span style="background: linear-gradient(90deg, #FF7111 0%, #C02B00 100%); -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; color: transparent;">{{ soccerhow.additional_info_introduce }}</span>
                    </div>
                    <p class="intro_paragraph">
                        {{ $Util.removeYoutubeLink(soccerhow.contents) }}
                    </p>
                </div>
            </div>

            <div class="section_container">
                <div style="margin-bottom: 20px;" class="section_header">
                    <span class="section_bar"></span>
                    <span class="section_title">첨부 자료</span>
                </div>
                <template v-if="videoSrcArr.length > 0">
                    <div class="attachment_container">
                        <img style="width: 20px;" :src="require('@/assets/img/play_video.png')" alt="">
                        <div class="attachment_title">{{ soccerhow.additional_info_name }} 선수 플레이 영상</div>
                    </div>
                    <div v-if="videoSrcArr.length > 0" class="video_wrapper_container hide_scroll">
                        <div v-for="each, i in videoSrcArr" :key="i + 'video'" @click="showVideoDetail(each.path, each.thumbnail_path)" class="video_wrapper">
                            <div style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                                <img style="width: 40px;" :src="require('@/assets/video_play_icon.png')" alt="">
                            </div>
                            <img class="video_item_img" :src="each.thumbnail_path" alt="">
                        </div>
                    </div>
                </template>
                <template v-if="youtubeLink !== ''">
                    <div class="attachment_container attachment_img">
                        <img style="width: 20px;" :src="require('@/assets/img/youtube_gray.png')" alt="">
                        <div class="attachment_title">{{ soccerhow.additional_info_name }} 선수의 유튜브 영상</div>
                    </div>
                    <div class="youtube_wrapper hide_scroll">
                        <div @click="showVideoDetailYoutube(youtubeLink)" style="flex-shrink: 0; width: 100%; position: relative;">
                            <img style="object-fit: cover; width: 100%; height: 100%;" :src="youtubeThumbImage">
                            <div style="position: absolute; z-index: 1; transform: translate(-50%, -50%); left: 50%; top: 50%;">
                                <img style="width: 52px;" :src="require('@/assets/youtube_icon.png')" alt="">
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="imgSrcArr.length > 0">
                    <div class="attachment_container attachment_img">
                        <img style="width: 16px;" :src="require('@/assets/img/play_image.png')" alt="">
                        <div class="attachment_title">{{ soccerhow.additional_info_name }} 선수의 이미지</div>
                    </div>
                    <div class="image_wrapper hide_scroll">
                    <div @click="showImageDetail(i)" v-for="each, i in imgSrcArr" :key="i + 'image'" class="image_item">
                            <img class="image_item_img" :src="each.thumbnail_path" alt="">
                        </div>
                    </div>
                </template>
                <div style="border-top: 1px solid #d9d9d9; padding-top: 15px; margin-top: 41px;">
                    <div style="display: flex; align-items: center; font-weight: 500; font-size: 14px; color: #808080; margin-bottom: 10px;">
                        <svg style="margin-right: 7px;" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.1298 12.4589C18.4962 12.4589 18.859 12.3867 19.1975 12.2465C19.536 12.1063 19.8436 11.9008 20.1027 11.6417C20.3617 11.3827 20.5673 11.0751 20.7075 10.7366C20.8477 10.3981 20.9198 10.0353 20.9198 9.66891C20.9198 9.30252 20.8477 8.93972 20.7075 8.60122C20.5673 8.26272 20.3617 7.95515 20.1027 7.69608C19.8436 7.437 19.536 7.23149 19.1975 7.09128C18.859 6.95107 18.4962 6.87891 18.1298 6.87891C17.3899 6.87891 16.6802 7.17285 16.157 7.69608C15.6338 8.2193 15.3398 8.92895 15.3398 9.66891C15.3398 10.4089 15.6338 11.1185 16.157 11.6417C16.6802 12.165 17.3899 12.4589 18.1298 12.4589Z" fill="black"/>
                            <path d="M6.7455 5.99988L7.2555 5.24988C8.193 5.24988 9.123 5.03238 9.963 4.62738L14.658 2.31738V17.0324L9.963 14.7224C9.12041 14.3085 8.19425 14.093 7.2555 14.0924L6.7455 12.7499V5.99988ZM3.1575 19.5059H5.088C5.5905 19.5059 5.9955 19.1009 5.9955 18.5984V12.6674H2.25V18.5984C2.25 19.1009 2.655 19.5059 3.1575 19.5059Z" fill="#D3D3D3"/>
                            <path d="M16.5525 0C15.9418 0 15.3562 0.242584 14.9244 0.674387C14.4926 1.10619 14.25 1.69184 14.25 2.3025V17.04C14.25 17.6507 14.4926 18.2363 14.9244 18.6681C15.3562 19.0999 15.9418 19.3425 16.5525 19.3425C17.1632 19.3425 17.7488 19.0999 18.1806 18.6681C18.6124 18.2363 18.855 17.6507 18.855 17.04V2.3025C18.8536 1.69227 18.6106 1.10742 18.1791 0.675918C17.7476 0.244416 17.1627 0.00138668 16.5525 0Z" fill="#FF7111"/>
                            <path d="M1.29525 5.25H7.5V14.085H1.29525C0.5775 14.085 0 13.5225 0 12.8325V6.51C0 5.8125 0.5775 5.25 1.29525 5.25Z" fill="#DD5900"/>
                        </svg>
                        현재 <span style="margin-left: 3px;" class="interest_count"> {{ ' ' + favorite_count }}건</span>의 관심을 받고 있어요
                    </div>
                    <div v-for="each, i in pushMessage" :key="i + 'pushMessage'" style="display: flex; gap: 12px; margin-bottom: 20px;">
                        <div @click.stop="$Util.showProfile(each.req_member.idx)" style="margin-top: 12px;">
                            <ProfileImage :imagePath="each.req_member.image_path" style="width: 40px; height: 40px;"></ProfileImage>
                        </div>
                        <div>
                            <div style="display: flex; align-items: center; gap: 4px;">
                                <div style="font-weight: 700; font-size: 12px; line-height: 24px;">{{ each.req_member.nic_name }}</div>
                                <img v-if="each.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                            </div>
                            <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 8px 12px; display: inline-block; border-radius: 12px;">
                                <div style="line-height: 24px; font-weight: 500; font-size: 15px;">{{ each.message }}</div>
                            </div>
                            <div style="font-size: 11px; font-weight: 500; color: #606060; line-height: 24px;">{{ each.push_date | agoDateStr }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="Object.keys(soccerhow).length > 0 && $GlobalStore.loginInfo().is_temp_coach == 1" class="bottom_button_container">
            <!-- <div class="interest_info">
                <img style="width: 22px;" :src="require('@/assets/img/eye_icon.png')" alt="">
                <span class="interest_text">
                    현재 <span class="interest_count">{{ favorite_count }}</span>개 구단이 관심 갖는 중
                </span>
            </div>
            <div class="button_row">
                <button :class="!isRejected ? '' : 'disabled'" @click="showRejectConfirmPopup" v-if="requestToCoachMessage && requestToCoachMessage.is_accepted == 0" class="heart_button">
                    <img v-if="!isRejected" class="heart_icon" :src="require('@/assets/img/broken_heart.png')" alt="">
                    <img v-else class="heart_icon" :src="require('@/assets/img/broken_heart_red.png')" alt="">
                </button>
                <button v-if="!isSentMessage && !isAccepted" @click="sendLikeToPlayer(1)" :class="!isRejected ? '' : 'disabled'" class="send_interest_button">
                    <img v-if="!isRejected" class="paper_plane_icon" :src="require('@/assets/img/message_orange.png')" alt="">
                    <img v-else class="paper_plane_icon" :src="require('@/assets/img/message_gray.png')" alt="">
                    <span class="send_interest_text">선수에게 관심 보내기</span>
                </button>
                <button v-else-if="isSentMessage && !isAccepted" @click="sendLikeToPlayer(3)" class="send_interest_button disabled">
                    <img style="width: 14px;" :src="require('@/assets/img/check_black.png')" alt="">
                    <span style="color: #210f03;" class="send_interest_text">관심 전달 완료</span>
                </button>
                <button @click="showChat" v-else-if="isSentMessage && isAccepted" style="background-color: var(--color-main); color: #fff;" class="send_interest_button">
                    <img class="paper_plane_icon" :src="require('@/assets/img/message_white.png')" alt="">
                    <span class="send_interest_text">메세지 보내기</span>
                </button>
            </div> -->
            <div style="display: flex; gap: 9px; margin-top: 8px; padding: 0 12px;">
                <InteractionOfScale style="flex: 1;" v-if="is_me_member_liked">
                    <div @click="cancelMemberLike(); $Util.sendEventClick('사커하우_요청서_관심선수취소', true)" style="display: flex; justify-content: center; align-items: center; gap: 4px; height: 60px; border-radius: 50px; font-size: 14px; font-weight: 700; background: linear-gradient(90deg, #FF7111 0%, #EABB56 50%, #FFC39A 100%);">
                        <img style="width: 16px" :src="require('@/assets/img/star_gold.png')" alt="">
                        <div>관심</div>
                    </div>
                </InteractionOfScale>
                <InteractionOfScale style="flex: 1;" v-else>
                    <div @click="sendLike(); $Util.sendEventClick('사커하우_요청서_관심선수등록', true)" style="display: flex; justify-content: center; align-items: center; gap: 4px; height: 60px; border-radius: 50px; font-size: 14px; font-weight: 700; background: linear-gradient(90deg, #FF7111 0%, #EABB56 50%, #FFC39A 100%);">
                        <img style="width: 16px" :src="require('@/assets/img/star_black.png')" alt="">
                        <div>관심</div>
                    </div>
                </InteractionOfScale>
                <InteractionOfScale style="flex: 1;">
                    <div @click="sendLikeToPlayer(1); $Util.sendEventClick('사커하우_요청서_다이렉트메시지', true)" style="height: 60px; gap: 4px; display: flex; justify-content: center; align-items: center; border-radius: 50px; font-size: 14px; font-weight: 700; background-color: #210f03; color: var(--color-main);">
                        <img style="width: 16px" :src="require('@/assets/img/dm_main_color.png')" alt="">
                        <div>스카웃 제안</div>
                    </div>
                </InteractionOfScale>
            </div>
        </div>
        <div v-else-if="Object.keys(soccerhow).length > 0 && $GlobalStore.loginInfo().idx == soccerhow.writer_idx" class="bottom_button_container">
            <div class="button_row">
                <button @click="goToModifyRequest" class="modify_button">
                    <img style="width: 16px;" :src="require('@/assets/img/modify_white.png')" alt="">
                    <span style="font-weight: 700;">입단 요청서 수정하기</span>
                </button>
            </div>
        </div>
        <CommonConfirmFrame v-if="isShowConfirmProfilePopup" :isShowConfirmPopup="isShowConfirmProfilePopup" :closeConfirmPopup="closeConfirmProfilePopup">
            <div class="common_container">
                <div class="common_circle blue">
                    <img style="width: 21px;" :src="require('@/assets/img/view_profile.png')" alt="">
                </div>
                <div class="common_title">상세 프로필을 열람할까요?</div>
                <div class="view_profile_text">
                    <span>진의선 </span>선수의 입단 요청서를 확인합니다
                </div>
                <div class="btn_wrapper">
                    <div @click="closeRequestReportDetail" class="common_btn cancel">취소</div>
                    <div @click="confirmRequestReportDetail" class="common_btn confirm">확인하기</div>
                </div>
            </div>
        </CommonConfirmFrame>
        <CommonConfirmFrame :popupTransform="popupTransform" :containerWidth="'calc(100% - 24px)'" v-if="isShowConfirmLikePopup" :isShowConfirmPopup="isShowConfirmLikePopup" :closeConfirmPopup="closeConfirmLikePopup">
            <div v-if="likePopupStep === 1" class="common_container">
                <div class="common_circle orange">
                    <img style="width: 20px;" :src="require('@/assets/img/direct_message_orange.png')" alt="">
                </div>
                <div class="common_title">선수에게 관심을 보냅니다</div>
                <div class="like_text">
                    감독님만의 특별한 어필로 선수의 마음을 사로잡으세요.
                </div>
                <div class="message_container">
                    <div class="message_title">어필 메시지</div>
                    <div class="message_box">
                        <textarea @focus="focusMessageInput" @blur="blurMessageInput" placeholder="예) 선수의 장점이 저희 팀과 어울리는 거 같아요. 입단 테스트 한 번 보러 오실래요?" v-model="messageContents" class="message_textarea" name="" id=""></textarea>
                    </div>
                </div>
                <div class="btn_wrapper">
                    <div @click="closeConfirmLikePopup" class="common_btn cancel_like">취소</div>
                    <div @click="sendDirectMessage" class="common_btn confirm_like">
                        <div>
                            <img style="width: 14px;" :src="require('@/assets/img/message_orange.png')" alt="">
                        </div>
                        <div>선수에게 관심 보내기</div>
                    </div>
                </div>
            </div>
            <div v-if="likePopupStep === 2" class="common_container">
                <div class="common_circle orange">
                    <img style="width: 20px;" :src="require('@/assets/img/direct_message_orange.png')" alt="">
                </div>
                <div class="common_title">전송 되었습니다</div>
                <div style="font-size: 14px;" class="like_text">감독님의 <span style="font-weight: 700; color: #210F03;">진심이 담긴 메시지</span>가 선수에게<br>전달되었습니다.</div>
                <div style="margin-top: 0;" class="like_text">선수가 수락하면 알림으로 알려드릴게요.</div>
                <div @click="closeConfirmLikePopup" style="background-color: #210F03; color: #fff; width: 195px; margin: 0 auto; margin-top: 20px;" class="common_btn">확인</div>
            </div>
            <div v-if="likePopupStep === 3" class="common_container">
                <div class="common_circle orange">
                    <img style="width: 20px;" :src="require('@/assets/img/direct_message_orange.png')" alt="">
                </div>
                <div class="common_title">이미 전달되었습니다</div>
                <div style="font-size: 14px;" class="like_text">선수 측에서 수락을 할 때 까지<br>조금만 기다려 주세요!</div>
                <div @click="closeConfirmLikePopup" style="background-color: #210F03; color: #fff; width: 195px; margin: 0 auto; margin-top: 20px;" class="common_btn">확인</div>
            </div>
        </CommonConfirmFrame>
        <CommonConfirmFrame :containerWidth="'calc(100% - 24px)'" v-if="isShowRejectConfirmPopup" :isShowConfirmPopup="isShowRejectConfirmPopup" :closeConfirmPopup="closeRejectConfirmPopup">
            <div v-if="rejectStep === REJECT_STEP.DEFAULT" class="common_container">
                <div class="common_circle red">
                    <img style="width: 20px;" :src="require('@/assets/img/broken_heart_red.png')" alt="" />
                </div>
                <div class="common_title">매칭을 거절하시겠습니까?</div>
                <div class="reject_text">선수에게<span>거절의 사유 </span>또는 <span>피드백(조언)</span>을 남겨주시면<br>선수의 성장에 큰 도움이 됩니다.</div>
                <div style="margin-bottom: 30px;" class="message_container">
                    <textarea v-model="rejectFeedbackMessage" placeholder="예) 스피드는 좋으나 볼 터치가 깁니다. 드리블 훈련을 보강하면 더 좋은 선수가 될 것 같습니다." class="message_textarea" name="" id=""></textarea>
                </div>
                <div class="btn_wrapper">
                    <div @click="rejectMatching(false)" class="common_btn reject_btn">그냥 거절하기</div>
                    <div @click="rejectMatching(true)" class="common_btn confirm">피드백 보내기</div>
                </div>
            </div>
            <div v-else-if="rejectStep === REJECT_STEP.REJECT" class="common_container">
                <div class="common_circle red">
                    <img style="width: 20px;" :src="require('@/assets/img/broken_heart_red.png')" alt="" />
                </div>
                <div class="common_title">매칭이 거절되었습니다.</div>
                <div class="reject_text">해당 선수의 입단 요청서 제안을 거절하셔서<br>비활성화 처리되었습니다.</div>
                <div style="margin-top: 30px;" class="btn_wrapper">
                    <div @click="closeRejectConfirmPopup" class="common_btn confirm">확인</div>
                </div>
            </div>
            <div v-else-if="rejectStep === REJECT_STEP.REJECT_FEEDBACK" class="common_container">
                <div class="common_circle orange">
                    <img style="width: 20px;" :src="require('@/assets/img/direct_message_orange.png')" alt="">
                </div>
                <div class="common_title">전송 되었습니다</div>
                <div style="font-size: 14px;" class="like_text">감독님의 <span style="font-weight: 700; color: #210F03;">진심이 담긴 메시지</span>가 선수에게<br>전달되었습니다.</div>
                <div @click="closeRejectConfirmPopup" style="background-color: #210F03; color: #fff; width: 195px; margin: 0 auto; margin-top: 20px;" class="common_btn">확인</div>
            </div>
            <div v-else-if="rejectStep === REJECT_STEP.REJECTED" class="common_container">
                <div class="common_circle red2">
                    <img style="width: 16px;" :src="require('@/assets/img/status_reject.png')" alt="">
                </div>
                <div class="common_title">거절 상태를 해제해 주세요</div>
                <div style="margin-top: 10px; color: #808080; font-size: 14px; line-height: 24px; font-weight: 500;">현재 거절하신 선수입니다.</div>
                <div style="font-size: 12px; font-weight: 500; color: #808080; line-height: 20px;">관심을 보내시려면 먼저 거절 버튼을 눌러<br>상태를 취소해주세요.</div>
                <div style="margin-top: 20px;">
                    <div @click="closeRejectConfirmPopup" class="common_btn confirm">확인</div>
                </div>
            </div>
        </CommonConfirmFrame>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions"></BottomPopupMenu>
        <BookmarkPopup :background="'#fff'" :height="280" :isShowBookmarkPopup="isShowLastTopPopup" :closeBookmarkPopup="closeLastTopPopup">
            <div>
                <div @click="closeLastTopPopup" style="font-weight: 700;">닫기</div>
                <div style="text-align: center; margin-top: 32px;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 28px;">다른 요청서에 묻혔나요?<br>요청서를 끌어올릴 수 있어요!</div>
                    <div style="margin-top: 20px; color: #606060; font-weight: 500; line-height: 24px;">• 7일에 한 번씩 게시물을 끌어올릴 수 있습니다.</div>
                    <div @click="goToTop" style="width: 210px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">끌어올리기▲</div>
                </div>
            </div>
        </BookmarkPopup>
    </div>
</template>

<script>
const REJECT_STEP = {
    DEFAULT: 1,
    REJECT: 2,
    REJECT_FEEDBACK: 3,
    REJECTED: 4
}

import ProfileImage from '@/components/common/ProfileImage'
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup'
import InteractionOfScale from '@/components/common/InteractionOfScale';
import CommonConfirmFrame from '@/components/common/CommonConfirmFrame'
import { PROFILE_FOOT_WAY, MEMBER_TYPE, JOIN_CHAT_TYPE, FORM_MODE, TEAM_TYPE, REPORT_TYPE_IDX, SOCCER_HOW_TYPE } from '@/Constants'
import ResponseCode from '@/ResponseCode'

export default {
    name: 'RequestReportDetailNew',
    props: {
        soccerhowIdx: {
            type: [Number, String],
            default: -1
        },
        is_parent_verified: {
            type: [Number, String],
            default: -1
        },
        completeAction: {
            type: Function,
            default: () => {}
        },
        is_from_pageframe: {
            type: Boolean,
            default: false
        }
    },
    components: { ProfileImage, CommonConfirmFrame, InteractionOfScale, BottomPopupMenu, BookmarkPopup },
    created() {
        const device = this.$cookies.get('device');
        this.device = device;
        // if (this.$GlobalStore.loginInfo().is_temp_coach == 1) {
        //     this.checkIsExistRequestViewLog()
        // } else {
        //     this.getRequestReportDetail()
        // }
        this.confirmRequestReportDetail()
    },
    computed: {
        isMeCreator() {
            if (this.$GlobalStore.isLogin() && this.soccerhow.writer_idx == this.$GlobalStore.loginInfo().idx) {
                return true
            } else {
                return false
            }
        },
        isSentMessage() {
            if((this.prev_direct_message && Object.keys(this.prev_direct_message).length > 0) || this.completeSendMessage) {
                return true
            }
            return false
        },
        isAccepted() {
            if(this.prev_direct_message && Object.keys(this.prev_direct_message).length > 0 && this.prev_direct_message.is_accepted == 1) {
                return true
            }
            return false
        }
    },
    data() {
        return {
            SOCCER_HOW_TYPE: SOCCER_HOW_TYPE,
            REPORT_TYPE_IDX: REPORT_TYPE_IDX,
            isShowPopMenu: false,
            isShowLastTopPopup: false,
            menuOptions: {},
            TEAM_TYPE: TEAM_TYPE,
            pushMessage: [],
            is_me_member_liked: false,
            device: null,
            FORM_MODE: FORM_MODE,
            REJECT_STEP: REJECT_STEP,
            PROFILE_FOOT_WAY: PROFILE_FOOT_WAY,
            soccerhow: {},
            imgSrcArr: [],
            videoSrcArr: [],
            contents: '',
            youtubeLink: '',
            youtubeThumbImage: '',
            isShowConfirmProfilePopup: false,
            requestToCoachMessage: null,
            isShowConfirmLikePopup: false,
            messageContents: '',
            likePopupStep: 1,
            favorite_count: 0,
            isShowRejectConfirmPopup: false,
            rejectFeedbackMessage: '',
            isRejected: false,
            rejectStep: REJECT_STEP.DEFAULT,
            prev_direct_message: {},
            completeSendMessage: false,
            MEMBER_TYPE: MEMBER_TYPE,
            JOIN_CHAT_TYPE: JOIN_CHAT_TYPE,
            popupTransform: 'translateY(0)'
        }
    },
    methods: {
        async deleteSoccerhow() {
            if (confirm('삭제 하시겠습니까?')) {
                const res = await this.$Axios.post('/api/soccerhow/delete', { deleteList: [this.soccerhowIdx] });

                if (res.data.code === 0) {
                    this.completeAction()
                    this.$GlobalStore.showAlert('요청서를 삭제했습니다.')
                    setTimeout(() => {
                        this.$GlobalStore.closeLastModal()
                    }, 500);
                }
            }
        },
        async goToTop() {
            const formData = new FormData()
            formData.append('soccerhow_idx', this.soccerhowIdx)

            const res = await this.$Axios.post('/api/soccerhow/last_top/update', formData)

            this.closeLastTopPopup()
            if (res.data.code == 0) {
                this.$GlobalStore.showAlert('요청서를 끌어올렸습니다.')
                this.completeAction()
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        closeLastTopPopup() {
            this.isShowLastTopPopup = false
        },
        shareTrainingRequest() {
            const message = '';
            let url = ''

            if (process.env.NODE_ENV === 'development') {
                url = 'http://192.168.0.203:8080';
            } else {
                if (process.env.VUE_APP_IS_TEST_SERVER !== undefined) {
                    url = 'https://obyungear-user-test.ubiplus.co.kr';
                } else {
                    url = 'https://app.soccerhow.com';
                }
            }

            url += '/training?type=' + 'request' + '&idx=' + this.soccerhow.idx + '&is_secret=false'
            // console.log(url);
            const device = this.$cookies.get('device');
            if (device === 'android') {
                const text = (message === "" ? "" : message + "\n") + url;
                window.Android.shareUrl(text);
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'shareUrl', text: message, url: url });
            }
        },
        setIsShowPopMenu() {
            this.isShowPopMenu = true
            const labelAndAction = []

            if (this.isMeCreator) {
                labelAndAction.push(
                    {
                        label: '수정하기', action: () => {
                            this.goToModifyRequest();
                            this.isShowPopMenu = false;
                        },
                    },
                    {
                        label: '삭제하기', action: () => {
                            this.deleteSoccerhow();
                            this.isShowPopMenu = false;
                        },
                    },
                    {
                        label: '끌어올리기', action: () => {
                            this.isShowLastTopPopup = true;
                            this.isShowPopMenu = false;
                        },
                    },
                    {
                        label: '공유하기', action: () => {
                            this.shareTrainingRequest();
                            this.isShowPopMenu = false;
                        },
                    }
                );
            } else {
                if (this.$GlobalStore.loginInfo().is_temp_coach == 1) {
                    labelAndAction.push(
                        {
                            label: '프로필 보기', action: () => {
                                this.$Util.showProfile(this.soccerhow.writer_idx, this.soccerhow.writer_type, '', 0);
                                this.isShowPopMenu = false
                            },
                        }
                    )
                }
                labelAndAction.push(
                    {
                        label: '신고하기', action: () => {
                            this.report();
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '공유하기', action: () => {
                            this.shareTrainingRequest();
                            this.isShowPopMenu = false
                        },
                    },
                )
            }

            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }
        },
        report() {
            this.$Util.sendEventClick('사커하우_게시물신고')

            let report_refer_type = '';

            if ([SOCCER_HOW_TYPE.SINGLE_TRAINING, SOCCER_HOW_TYPE.GROUP_TRAINING].indexOf(this.soccerhow.type) > -1) {
                report_refer_type = REPORT_TYPE_IDX.SOCCERHOW_TRAINING;
            } else if ([SOCCER_HOW_TYPE.SC_JOB, SOCCER_HOW_TYPE.SC_JOIN, SOCCER_HOW_TYPE.SC_COUNSEL].indexOf(this.soccerhow.type) > -1) {
                report_refer_type = REPORT_TYPE_IDX.SOCCERHOW_REQUEST;
            }

            this.$GlobalStore.addModal('ReportPopup',
                {
                    isModalBackTransparent: true,
                    target_member_idx: this.target_member.idx,
                    target_member_type: this.soccerhow.writer_type,
                    refer_type: report_refer_type,
                    refer_idx: this.soccerhow.idx,
                    report_title: this.soccerhow.title,
                    report_contents: this.soccerhow.contents
                }
            );
        },
        async cancelMemberLike() {
            const parameters = {};
            parameters.soccerhow_idx = this.soccerhow.idx;
            const res = await this.$Axios.post('/api/like/soccerhow/interest/delete', parameters)
            if (res.data.code === ResponseCode.SUCCESS) {
                this.is_me_member_liked = false;
                this.getRequestReportDetail();
                this.favorite_count = this.favorite_count - 1;
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async sendLike() {
            const formData = new FormData()
            formData.append('target_idx', this.soccerhow.writer_idx);
            formData.append('from', 'request')
            formData.append('refer_idx', this.soccerhow.idx);
            formData.append('is_from_detail', true);

            const res = await this.$Axios.post('/api/like/soccerhow/interest/save', formData)
            if (res.data.code === ResponseCode.SUCCESS) {
                this.is_me_member_liked = true;
                this.getRequestReportDetail();
                this.favorite_count = this.favorite_count + 1;
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        focusMessageInput() {
            if (this.device !== 'pc') {
                this.popupTransform = 'translateY(100px)'
            }
        },
        blurMessageInput() {
            this.popupTransform = 'translateY(0)'
        },
        goToModifyRequest() {
            this.$GlobalStore.addModal('ModifyWriteDefaultInfoForm', { soccerhowIdx: this.soccerhowIdx, mode: FORM_MODE.UPDATE, completeAction: () => {
                this.getRequestReportDetail(true)
            } });
        },
        transFootWay(footWay) {
            if (footWay == 0) {
                return 'B'
            } else if (footWay == 1) {
                return 'L'
            } else if (footWay == 2) {
                return 'R'
            } else {
                return ''
            }
        },
        showChat() {
            this.$Axios.showPersonalChat(this.target_member.idx, MEMBER_TYPE.USER, JOIN_CHAT_TYPE.CHAT_WITH_COACH);
        },
        async rejectMatching(is_feedback) {
            if (!is_feedback) {
                this.rejectFeedbackMessage = ''
            }
            const formData = new FormData()
            formData.append('is_accepted', false)
            formData.append('direct_message_idx', this.requestToCoachMessage.idx)
            formData.append('feedback_message', this.rejectFeedbackMessage)
            formData.append('is_feedback', is_feedback)
            formData.append('is_reject_popup', true)

            const res = await this.$Axios.post('/api/direct_message/change/status', formData);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.isRejected = true
                this.rejectFeedbackMessage = ''
                if (is_feedback) {
                    this.rejectStep = REJECT_STEP.REJECT_FEEDBACK
                } else {
                    this.rejectStep = REJECT_STEP.REJECT
                }
            }
        },
        showRejectConfirmPopup() {
            if (this.isRejected) {
                this.changeIsSkip()
            } else {
                this.isShowRejectConfirmPopup = true
            }
        },
        async changeIsSkip() {
            const formData = new FormData()
            formData.append('direct_message_idx', this.requestToCoachMessage.idx)
            formData.append('change_is_skip', true)
            const res = await this.$Axios.post('/api/direct_message/change/status', formData);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.isRejected = false
                this.rejectStep = REJECT_STEP.DEFAULT
            }
        },
        closeRejectConfirmPopup() {
            this.isShowRejectConfirmPopup = false
        },
        closeConfirmLikePopup() {
            this.messageContents = ''
            this.isShowConfirmLikePopup = false
        },
        sendLikeToPlayer(step) {
            // if (this.isRejected) {
            //     this.rejectStep = REJECT_STEP.REJECTED
            //     this.isShowRejectConfirmPopup = true
            //     return
            // }
            this.likePopupStep = step
            this.isShowConfirmLikePopup = true
        },
        async sendDirectMessage() {
            if (this.messageContents.length < 5) {
                this.$GlobalStore.showAlert('5글자 이상 입력해주세요')
                return
            }
            const formData = new FormData()
            formData.append('refer_idx', this.soccerhowIdx)
            formData.append('contents', this.messageContents)

            const res = await this.$Axios.post('/api/direct_message/send', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.messageContents = ''
                this.likePopupStep = 2
                this.completeSendMessage = true
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        async checkIsExistRequestViewLog() {
            const parameters = {}
            parameters.soccerhow_idx = this.soccerhowIdx

            const res = await this.$Axios.get('/api/soccerhow/request_view_log', { params: parameters })
            if (res.data.is_exist) {
                this.getRequestReportDetail()
            } else {
                this.isShowConfirmProfilePopup = true
            }
        },
        closeConfirmProfilePopup() {
            this.isShowConfirmProfilePopup = false
        },
        async confirmRequestReportDetail() {
            const formData = new FormData()
            formData.append('soccerhow_idx', this.soccerhowIdx)
            const res = await this.$Axios.post('/api/soccerhow/save/request_view_log', formData)
            if (res.data.code == ResponseCode.SUCCESS) {
                this.getRequestReportDetail()
                this.isShowConfirmProfilePopup = false
            }
        },
        closeRequestReportDetail() {
            this.$GlobalStore.closeLastModal()
        },
        showVideoDetailYoutube(path) {
            this.$GlobalStore.addModal('VideoViewer', { urlPath: path, isYoutube: true, status_bar_text_color: 'white' })
        },
        async getRequestReportDetail(isUpdate) {
            const parameters = {}
            parameters.soccerhow_idx = this.soccerhowIdx;
            parameters.is_from_list = true;
            parameters.is_visit = true;

            const res = await this.$Axios.get('/api/soccerhow/detail', { params: parameters })
            if (res.data.code == ResponseCode.SUCCESS) {
                this.soccerhow = res.data.soccerhow;
                this.requestToCoachMessage = res.data.request_to_coach_message;
                this.favorite_count = res.data.favorite_count;
                this.target_member = res.data.member;
                this.is_me_member_liked = res.data.is_me_member_liked;
                this.prev_direct_message = res.data.prev_direct_message;
                const pushMessage = res.data.push_messages || []
                this.pushMessage = pushMessage
                if (this.requestToCoachMessage) {
                    if (this.requestToCoachMessage.is_skip == 1) {
                        this.isRejected = true
                    }
                }
            }
            if (isUpdate) {
                this.imgSrcArr = []
                this.videoSrcArr = []
            }
            this.setMediaPath()
            this.getYoutubeLink()
        },
        getYoutubeLink() {
            if (this.$Util.getYoutubeLinkArr(this.soccerhow.contents)) {
                this.youtubeLink = this.$Util.getYoutubeLinkArr(this.soccerhow.contents)[0]
                this.contents = this.$Util.removeYoutubeLink(this.soccerhow.contents)
                const thumb_image = this.$Util.getYoutubeThumbnail(this.youtubeLink)
                this.youtubeThumbImage = thumb_image
            } else {
                this.contents = this.soccerhow.contents
            }
        },
        setMediaPath() {
            for (let i = 1; i < 4; i++) {
                const key = `media_path${i}`;
                const extension = this.soccerhow[key] ? this.soccerhow[key].split('.').pop().toLowerCase() : '';
                const thumbnail_key = `thumbnail_path${i}`
                if (this.soccerhow[key] && (extension === 'mp4' || extension === 'mov' || extension === 'qt')) {
                    this.videoSrcArr.push({
                        path: this.$resourcePath + this.soccerhow[key],
                        thumbnail_path: this.$resourcePath + this.soccerhow[thumbnail_key]
                    })
                }

                if (this.soccerhow[key] && (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp')) {
                    this.imgSrcArr.push({
                        path: this.$resourcePath + this.soccerhow[key],
                        thumbnail_path: this.$resourcePath + this.soccerhow[thumbnail_key],
                        imageViewerPath: this.soccerhow[key]
                    })
                }
            }
        },
        setFootWay(footWay) {
            if (footWay == PROFILE_FOOT_WAY.LEFT) {
                return '왼발'
            } else if (footWay == PROFILE_FOOT_WAY.RIGHT) {
                return '양발'
            } else {
                return '오른발'
            }
        },
        showVideoDetail(path, thumbnail_path) {
            this.$GlobalStore.addModal('VideoViewer', { urlPath: path, isYoutube: false, thumbnail_path: thumbnail_path, status_bar_text_color: 'white' })
        },
        showImageDetail(index) {
            const imgSrcArr = []
            this.imgSrcArr.forEach(item => {
                imgSrcArr.push(item.imageViewerPath)
            })
            this.$GlobalStore.addModal('ImageViewer', { imagePaths: imgSrcArr, initIndex: index })
        }
    }
}
</script>

<style scoped>
.common_tag {
    border: 2px solid #fff;
    width: 89px;
    border-radius: 40px;
    font-weight: 700;
    font-size: 14px;
    color: #fff;
    text-align: center;
    padding: 6px 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -16px;
}

.elite_tag {
    background: linear-gradient(90deg, #FA6B18 0%, #FB8634 100%);
}

.not_elite_tag {
    background: linear-gradient(90deg, #295B94 0%, #86BCFA 100%);
}

.common_container {
    padding: 8px;
    text-align: center;
}

.profile_header_section {
    background-color: #fff;
    margin-top: 23px;
    border-radius: 24px;
    margin-bottom: 18px;
    padding: 20px 12px;
}

.profile_main {
    display: flex;
    gap: 16px;
    flex-direction: column;
    align-items: center;
}

.profile_info_main {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.name_row_main {
    display: flex;
    align-items: center;
    justify-content: center;
}

.player_name_large {
    font-size: 24px;
    font-weight: 900;
}

.player_name {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 20px;
    font-weight: 700;
    line-height: 32px;
    color: #000;
}

.location {
    font-size: 14px;
    line-height: 16px;
    color: #808080;
    text-align: center;
    margin-top: 3px;
}

.registration_date {
    font-size: 12px;
    /* color: #808080; */
    font-weight: 500;
    white-space: nowrap;
    text-align: center;
    line-height: 24px;
    margin-top: 5px;
}

.tags_row {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.tag {
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    white-space: nowrap;
}

.verified_tag {
    background: #82FFAD33;
    border: 1px solid #82FFAD;
    display: flex;
    color: #159941;
    align-items: center;
    gap: 4px;
}

.not_verified_tag {
    background: #C8C8C84D;
    border: 1px solid #c8c8c8;
    display: flex;
    align-items: center;
    gap: 4px;
    color: #989898;
}


.info_list {
    display: flex;
    flex-direction: column;
    margin-top: 11px;
}

.info_item {
    display: flex;
    align-items: center;
    gap: 30px;
    margin-top: 4px;
}

.info_label {
    font-size: 14px;
    font-weight: 500;
    color: #808080;
    width: 66px;
    line-height: 24px;
}

.info_value {
    font-size: 14px;
    font-weight: 700;

}

.section_container {
    margin-bottom: 28px;
}

.section_header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}

.section_bar {
    background-color: var(--color-main);
    font-size: 16px;
    width: 3px;
    font-weight: 700;
    height: 20px;
    border-radius: 4px
}

.section_title {
    font-size: 14px;
    font-weight: 700;
}

.stats_section_detailed {
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 15px;
}

.stat_item_detailed {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    align-items: center;
    gap: 10px;
    flex: 1;
    padding: 15px 0;
    border-radius: 12px;
    border: 1px solid #E6E6E6;
    box-shadow: 0px 0px 10px 0px #0000001A;
}

.stat_label_detailed {
    font-size: 12px;
    color: #aaa;
    font-weight: 700;
}

.stat_value_detailed {
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: baseline;
    gap: 2px;
}

.stat_number {
    font-size: 16px;
    font-weight: 700;
}

.stat_unit {
    font-size: 12px;
}

.stat_divider_detailed {
    width: 1px;
    height: 25px;
    background-color: #cdcdcd;
    margin: 0 8px;
}

.quote_box {
    background-color: #fff;
    border-radius: 8px;
    padding: 12px;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 16px;
}


.intro_paragraph {
    font-size: 14px;
    line-height: 24px;
    color: #333;
    margin: 0;
    margin-top: 13px;
    font-weight: 400;
    word-break: break-all;

}

.attachment_container {
    display: flex;
    align-items: center;
    gap: 7px;
}

.attachment_title {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #808080;
}

.video_wrapper_container {
    display: flex;
    gap: 12px;
    overflow-x: scroll;
    margin: 0 -12px;
    padding: 0 12px;
}

.youtube_wrapper {
    border-radius: 24px;
    overflow: hidden;
    height: 194px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}

.video_wrapper {
    flex-shrink: 0;
    position: relative;
    height: 194px;
    width: 342px;
    border-radius: 24px;
    background-color: #F5F5F5;
    margin-top: 10px;
    overflow: hidden;
}

.video_item_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.attachment_img {
    margin-top: 30px;
}

.image_wrapper {
    display: flex;
    gap: 12px;
    margin-top: 10px;
    overflow-x: scroll;
}

.image_item {
    width: 200px;
    height: 200px;
    border-radius: 12px;
    background-color: #F5F5F5;
    flex-shrink: 0;
    overflow: hidden;
}

.image_item_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.bottom_button_container {
    padding: 16px 12px;
}

.interest_info {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
}

.interest_text {
    font-size: 13px;
    color: #666;
    font-weight: 400;
}

.interest_count {
    color: #FF7131;
    font-weight: 700;
}

.button_row {
    display: flex;
    gap: 12px;
    align-items: center;
}

.heart_button {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background-color: #E0E0E0;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
}

.disabled {
    background-color: #210f03;
}

.heart_icon {
    width: 20px;
}

.send_interest_button {
    flex: 1;
    height: 48px;
    border-radius: 12px;
    background-color: #210F03;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    color: var(--color-main);
}

.modify_button {
    flex: 1;
    height: 50px;
    border-radius: 12px;
    background-color: #210F03;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: #fff;
    font-size: 14px;
}

.send_interest_button.disabled {
    background-color: #d9d9d9;
    color: #808080;
}

.paper_plane_icon {
    width: 14px;
}

.send_interest_text {
    font-size: 14px;
    font-weight: 700;
}

.common_circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

.blue {
    background-color: #ecf5ff;
}

.common_title {
    margin-top: 15px;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
}

.view_profile_text {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    margin-top: 5px;
    color: #808080;
    margin-bottom: 30px;
}

.view_profile_text span {
    font-weight: 700;
    color: #210f03;
}

.btn_wrapper {
    display: flex;
    gap: 18px;
}

.common_btn {
    padding: 14px 0;
    line-height: 18px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
}

.cancel {
    flex: 1;
    border: 1px solid #808080;
    min-width: 150px;
}

.confirm {
    flex: 1;
    min-width: 150px;
    background-color: #210f03;
    color: #fff;
}

.orange {
    background-color: #FFECDF;
}

.red {
    background-color: #FEF0F0;
}

.red2 {
    background-color: #FF000033
}

.like_text {
    font-size: 12px;
    line-height: 24px;
    color: #808080;
    margin-top: 10px;
    font-weight: 500;
}

.message_container {
    margin-top: 10px;
}

.message_title {
    text-align: left;
    line-height: 24px;
    font-size: 14px;
    font-weight: 700;
}

.message_box {
    margin-top: 5px;
    margin-bottom: 25px;
}

.message_textarea {
    border-radius: 12px;
    background: #210F030D;
    padding: 10px 20px;
    width: 100%;
    border: none;
    min-height: 97px;
    outline: none;
    font-size: 14px;
    line-height: 24px;
}

.message_textarea::placeholder {
    color: #bbb;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
}

.cancel_like {
    border: 1px solid #808080;
    flex-basis: 35%
}

.confirm_like {
    flex-basis: 65%;
    background-color: #111725;
    color: var(--color-main);
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
}

.reject_text {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #808080;
    margin-top: 5px;

}

.reject_text span {
    font-weight: 700;
    color: #210F03;
}

.reject_btn {
    border: 1px solid #808080;
    width: 112px;
}
</style>
